// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1Ao6i","header":"MessagesList_header__13aTM","chat":"MessagesList_chat__3NRE7"};